import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Grid,
  Typography,
  FormControl,
  Box,
  CircularProgress,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

// ----------------------------------------------------------------------

export default function EditConferencePage() {
  const fields = [{ title: "Name", name: "name" }];
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [conferenceId, setConferenceId] = useState(false);
  const [competition, setCompetition] = useState(null);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    competition: "",
    align: "",
  });
  const [isFilled, setFilling] = useState(true);

  useEffect(() => {
    if (searchParams.has("conferenceId")) {
      setLoading(true);

      let conferenceId = searchParams.get("conferenceId");
      setConferenceId(Number(conferenceId));

      const fetchDataConferences = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/conferences/${conferenceId}`
        );
        setData(data);
        return data;
      };
      fetchDataConferences()
        .finally(() => setLoading(false))
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setData((prevState) => ({ ...prevState, competition }));
      setCompetition(competition)
    }
  }, [searchParams]);

  useEffect(() => {
    const count = Object.values(data).filter(
      (field) => field?.length <= 0
    ).length;
    if (!count || data.name) setFilling(true);
    else setFilling(false);
  }, [data]);

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    if (!!data) {
      setLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/conferences/${conferenceId}`,
          data
        )
        .then(function (response) {
          navigate(`/dashboard/conferences?type=${competition}`);
        });
    }
  };
  return (
    <>
      <Helmet>
        <title> Conference </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Create Conference
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                {fields.map((field) => (
                  <FormControl
                    key={field.name}
                    sx={{ m: 1, minWidth: 620 }}
                    size="small"
                  >
                    <TextField
                      required
                      label={field.title}
                      placeholder={field.title}
                      name={field.name}
                      value={data[field.name] || ""}
                      onChange={(e) => handleChange(e)}
                      variant="outlined"
                    />
                  </FormControl>
                ))}
                 <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-align">
                    Position
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-align"
                    id="demo-simple-select-align"
                    value={data?.align || ""}
                    label="Position"
                    name="align"
                    onChange={(e) => handleChange(e)}
                  >
                    {['left', 'right', 'center'].map((positionItem, index) => (
                      <MenuItem
                        value={positionItem}
                        key={positionItem}
                      >
                        {positionItem}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  disabled={!isFilled}
                  onClick={() => handleSubmit()}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
